import {
  funcLoad,
} from './index';

const accessMain = () => {
  const pageAccess = (document.getElementById("pageAccess") != null);
  if (pageAccess) {



    let main = document.getElementById("main")
    let jsSecBg = document.getElementById("jsSecBg")
    let jsComParticleJsWrap = document.getElementById("jsComParticleJsWrap")
    // let particleWrap = jsSecBg.querySelector(".js-particle-wrap")
    // let particle = jsSecBg.querySelector(".js-particle")
    let jsSecMain = document.getElementById("jsSecMain")
    let copyBox = jsSecMain.querySelector(".js-copy-box")
    let imgBoxs = jsSecMain.querySelectorAll(".js-img-box")


    funcLoad()


    setTimeout(() => {

      // particle.classList.add('act')
      // particle.src = particle.src

      jsComParticleJsWrap.classList.add('act')

      setTimeout(() => {
        copyBox.classList.add('act')
      }, 1000);

      setTimeout(() => {
        let num = 0;
        gsap.to(imgBoxs, {
          stagger: {
            each: .5,
            from: "start",//最後の要素から再生
            onComplete: () => {
              imgBoxs[num].classList.add('act')
              num = num + 1
            },
          },
        });
      }, 1500);

      setTimeout(() => {
        // particleWrap.classList.add('act')
      }, 2000);
      setTimeout(() => {
        // particle.classList.add('none')
      }, 17700);

    }, 300);



    let sW = window.innerWidth;

    let y = []

    if (sW > 750) {
      y[0] = -50;
      y[1] = -200;
      y[2] = -150;
      y[3] = -70;
    } else {
      y[0] = -25;
      y[1] = -100;
      y[2] = -75;
      y[3] = -35;
    }

    for (let i = 0; i < imgBoxs.length; i++) {

      gsap.to(imgBoxs[i], {
        y: y[i],
        ease: "none",
        scrollTrigger: {
          trigger: main,
          start: 'top top',
          endTrigger: jsSecMain,
          end: 'bottom top',
          scrub: 0,
          // markers: true
        }
      })

    }


  }
}
export default accessMain;